export const DEFAULT_TRUSTED_PROTOCOLS = [
  'http',
  'https',
  'randatheopensso',
  'aigwo',
];

export const DEFAULT_TRUSTED_DOMAINS = [
  'theopen.com',
  'aigwomensopen.com',
  'oneclub.golf',
  'randa.tv',
  'randa.org',
  'localhost:3000',
  'localhost:4200',
  'localhost:4300',
  'localhost:4500',
  'localhost:4501',  
  'master.iris.qc.frgcloud.com',
  'stripe.com',
];
